export const config = {
  coin: {
    alpha: {
      start: 1,
      end: 1,
    },
    scale: {
      start: 0.1,
      end: 1,
    },
    speed: {
      start: 1000,
      end: 200,
    },
    acceleration: {
      x: 0,
      y: 2000,
    },
    startRotation: {
      min: 250,
      max: 290,
    },
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 5,
      max: 10,
    },
    blendMode: 'normal',
    frequency: 0.025,
    emitterLifetime: 0,
    maxParticles: 1000,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: 'circle',
    spawnCircle: {
      x: 0,
      y: 0,
      r: 0,
    },
  },
}
